// Chamada a rotas ainda fora do contrato gerado (`schema.d.ts`), pelo mesmo cliente tipado e seus middlewares
// (bearer, correlação, idioma, propósito, idempotência, problem+json → GiyusApiError) — mesma técnica de
// `@giyus/api-client` `getMe()` (TODO GIY-036), usada aqui para as rotas preview de Workflow/Notifications
// (TODO(GIY-023)/TODO(GIY-025): trocar por `client.GET(...)`/`client.POST(...)` tipados quando o contrato
// trouxer estas rotas, na integração pós A/B — ver design M1 §8 "Before the contract exists").
import type { GiyusClient } from '@giyus/api-client';

export type PreviewHttpMethod = 'get' | 'post' | 'put' | 'delete';

export interface PreviewRequestOptions {
  readonly body?: unknown;
  readonly headers?: Readonly<Record<string, string>>;
}

type RawRequest = (
  method: string,
  url: string,
  init?: { readonly body?: unknown; readonly headers?: Readonly<Record<string, string>> },
) => Promise<{ readonly data?: unknown; readonly error?: unknown }>;

/** Executa uma requisição preview e devolve o corpo tipado como `TResponse` (o servidor é a fonte de verdade). */
export async function previewRequest<TResponse>(
  client: GiyusClient,
  method: PreviewHttpMethod,
  path: string,
  options: PreviewRequestOptions = {},
): Promise<TResponse> {
  const raw = client.request as unknown as RawRequest;
  const init =
    options.body !== undefined || options.headers !== undefined
      ? {
          ...(options.body !== undefined ? { body: options.body } : {}),
          ...(options.headers ? { headers: options.headers } : {}),
        }
      : undefined;
  const { data } = await raw(method, path, init);
  return data as TResponse;
}
